import { NavigationHeaderContext } from "./NavigationHeaderContext";
import { delCookie } from "../utils/cookies";
import { generateRandomStr, userAvatar } from "../utils";
import { Col, Row, Space } from 'antd';
import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { mainlandArea } from "./locale";
var HeaderUserPopover = function HeaderUserPopover() {
  var NavigationHeaderContextProps = useContext(NavigationHeaderContext);
  var env = NavigationHeaderContextProps.env,
    testPassportUrl = NavigationHeaderContextProps.testPassportUrl,
    prodPassportUrl = NavigationHeaderContextProps.prodPassportUrl,
    dropDownMenu = NavigationHeaderContextProps.dropDownMenu,
    uid = NavigationHeaderContextProps.uid,
    username = NavigationHeaderContextProps.username,
    onLogout = NavigationHeaderContextProps.onLogout,
    locale = NavigationHeaderContextProps.locale;
  var mainland = mainlandArea(locale);
  var fixedMenuItem = {
    home: /*#__PURE__*/React.createElement("div", {
      className: "section-item",
      onClick: function onClick() {
        window.open("https://bbs.fanruan.com/u/".concat(uid));
      }
    }, /*#__PURE__*/React.createElement("img", {
      className: "section-item-icon",
      src: "https://hwobs.fanruan.com/ui/digit-fe/header/header-user.png"
    }), "\u6211\u7684\u4E3B\u9875"),
    task: /*#__PURE__*/React.createElement("div", {
      className: "section-item",
      onClick: function onClick() {
        window.open('https://bbs.fanruan.com/task-my.html');
      }
    }, /*#__PURE__*/React.createElement("img", {
      className: "section-item-icon",
      src: "https://hwobs.fanruan.com/ui/digit-fe/header/header-calendar.png"
    }), "\u6211\u7684\u4EFB\u52A1"),
    class: /*#__PURE__*/React.createElement("div", {
      className: "section-item",
      onClick: function onClick() {
        window.open('https://edu.fanruan.com/class');
      }
    }, /*#__PURE__*/React.createElement("img", {
      className: "section-item-icon",
      src: "https://hwobs.fanruan.com/ui/digit-fe/header/header-report.png"
    }), "\u6211\u7684\u73ED\u7EA7")
  };
  var createDropDownMenu = function createDropDownMenu() {
    console.log('dropDownMenu是', dropDownMenu);
    if (dropDownMenu && Array.isArray(dropDownMenu)) {
      return dropDownMenu.map(function (item) {
        if (typeof item === 'string') {
          if (fixedMenuItem[item]) {
            return /*#__PURE__*/React.createElement(Col, {
              span: 12,
              key: item
            }, fixedMenuItem[item]);
          }
          return null;
        }
        if ( /*#__PURE__*/React.isValidElement(item)) {
          return /*#__PURE__*/React.createElement(Col, {
            span: 12,
            key: generateRandomStr()
          }, item);
        }
        return null;
      });
    }
    return ['home', 'task', 'class'].map(function (item) {
      return /*#__PURE__*/React.createElement(Col, {
        span: 12,
        key: generateRandomStr()
      }, fixedMenuItem[item]);
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "dr-nav-popover-inner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dr-nav-popover-inner-section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "avatar-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "detail-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "username-info"
  }, username), /*#__PURE__*/React.createElement(Space, {
    className: "uid-info"
  }, "uid: ", uid), /*#__PURE__*/React.createElement(Space, {
    size: 40
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://fanruanclub.com/#/info/",
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "login.account.user.info"
  })), mainland && /*#__PURE__*/React.createElement("a", {
    href: "https://fanruanclub.com/#/info/auth",
    target: "_blank",
    rel: "noreferrer"
  }, "\u8D26\u53F7\u8BA4\u8BC1"))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
    className: "dr-nav-popover-inner-logo-big",
    src: userAvatar(uid)
  })))), mainland && /*#__PURE__*/React.createElement("div", {
    className: "dr-nav-popover-inner-section"
  }, /*#__PURE__*/React.createElement(Row, null, createDropDownMenu())), /*#__PURE__*/React.createElement("div", {
    className: "dr-nav-popover-inner-section",
    onClick: function onClick() {
      if (onLogout) {
        onLogout === null || onLogout === void 0 || onLogout();
      } else {
        var url = env === 'prod' ? prodPassportUrl : testPassportUrl;
        delCookie('fr_token');
        window.location.href = "".concat(url, "/login/token/logout?referrer=").concat(window.location.href);
      }
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "section-item"
  }, /*#__PURE__*/React.createElement("img", {
    className: "section-item-icon",
    src: "https://hwobs.fanruan.com/ui/digit-fe/header/header-logout.png"
  }), /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "logout"
  }))));
};
export default HeaderUserPopover;